// import { Baby, BabyDiet, MicrobiomeTest, Parent } from '@snapi/types';
// import { useContext, createContext } from 'react';

// export type ReportContent = {
//   test: Pick<MicrobiomeTest, 'id' | 'diet'>;
//   baby: Pick<Baby, 'name'> & { ageInMonths: number };
//   parent: Pick<Parent, 'name' | 'email'>;
// };

// export const ReportContext = createContext<ReportContent>({
//   test: { id: 'SNP-T001', diet: [BabyDiet.Breastmilk] },
//   baby: { name: 'Jimmy', ageInMonths: 12 },
//   parent: { name: 'Wesley', email: 'info@snapihealth.com' },
// });

// export const useReportContext = () => useContext(ReportContext);
import { Baby, BabyDiet, MicrobiomeTest, Parent, Gender } from '@snapi/types';
import { useContext, createContext } from 'react';

export type ReportContent = {
  test: Pick<MicrobiomeTest, 'id' | 'diet'>;
  baby: Pick<Baby, 'name' | 'gender'> & { ageInMonths: number };
  parent: Pick<Parent, 'name' | 'email'>;
};

export const ReportContext = createContext<ReportContent>({
  test: { id: 'SNP-T001', diet: [BabyDiet.Breastmilk] },
  baby: { name: 'Jimmy', gender: Gender.boy, ageInMonths: 12 },
  parent: { name: 'Wesley', email: 'info@snapihealth.com' },
});

export const useReportContext = () => useContext(ReportContext);

